import React, { FC, PropsWithChildren } from "react";

import { ButtonGenericProps } from "./button-generic-props";
import { getButtonClassName } from "./get-button-class-name";

export interface ButtonProps
  extends Pick<
      React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
      "onClick" | "className" | "type" | "disabled"
    >,
    ButtonGenericProps {}

export const Button: FC<PropsWithChildren<ButtonProps>> = ({
  variant = "neutral",
  size = "md",
  className: _className,
  children,
  fullWidth,
  disabled,
  ...props
}) => {
  const className = getButtonClassName({
    size,
    variant,
    fullWidth,
    disabled: disabled,
    customClassName: _className,
  });

  return (
    <button className={className} type={props?.type ?? "button"} disabled={disabled} {...props}>
      {children}
    </button>
  );
};
